import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  AutocompleteControls,
  AutocompleteControlsItem,
  AutocompleteControlsTriggeredEvent,
} from '../autocomplete.interfaces';

@Component({
  selector: 'app-autocomplete-controls',
  templateUrl: 'autocomplete-controls.component.html',
  styleUrls: ['./autocomplete-controls.component.scss'],
})
export class AutocompleteControlsComponent {
  @Input() config: AutocompleteControls;

  @Input() disabled = false;

  @Output() triggered = new EventEmitter<AutocompleteControlsTriggeredEvent>();

  get edit(): AutocompleteControlsItem {
    return this.config?.edit;
  }

  get clear(): AutocompleteControlsItem {
    return this.config?.clear;
  }

  get create(): AutocompleteControlsItem {
    return this.config?.create;
  }

  get delete(): AutocompleteControlsItem {
    return this.config?.delete;
  }

  triggerControl(triggerName: keyof AutocompleteControls): void {
    this.triggered.emit({ triggerName });
  }
}
